import { render, staticRenderFns } from "./ExportContainer.vue?vue&type=template&id=2fb1fb86"
import script from "./ExportContainer.vue?vue&type=script&lang=js"
export * from "./ExportContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports